import { useEffect } from 'react';
import { supabase } from '../config/supabase';

const STORAGE_KEY = 'supabase_keepalive_last_ping';
const PING_INTERVAL_DAYS = 5; // ping if no activity for 5 days
const CHECK_INTERVAL_MS = 6 * 60 * 60 * 1000; // re-check every 6 hours while app is open

async function pingSupabase() {
  try {
    await supabase.from('users').select('id').limit(1);
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    console.log('[keepalive] Supabase ping sent');
  } catch {
    // silently ignore — just a keepalive, not critical
  }
}

function shouldPing(): boolean {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return true;
  const lastPing = parseInt(raw, 10);
  if (isNaN(lastPing)) return true;
  const daysSincePing = (Date.now() - lastPing) / (1000 * 60 * 60 * 24);
  return daysSincePing >= PING_INTERVAL_DAYS;
}

export function useSupabaseKeepalive() {
  useEffect(() => {
    if (shouldPing()) {
      pingSupabase();
    }

    const interval = setInterval(() => {
      if (shouldPing()) {
        pingSupabase();
      }
    }, CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);
}
